export const MenuItemsData = [
    {
        id:1,
        title : 'Beranda',
        path : '/home',
        svg : {
            width:"24", 
            height:"24", 
            viewBox:"0 0 24 24", 
            fill:"none", 
            xmlns:"http://www.w3.org/2000/svg"},
        pathIcon : {
            d:"M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z",
            fill:["#0F4187", "" ], 
            stroke:["#0F4187", "black" ],
            stroke_opacity: ["", "0.6" ],
            stroke_width:"1.5",
            stroke_linecap:"round",
            stroke_linejoin:"round"
        }
    },
    {
        id:2,
        title : 'Kalkulasi',
        path : '/kalkulasi',
        svg : {
            width:"24",
            height:"24",
            viewBox:"0 0 24 24",
            fill:"none",
            xmlns:"http://www.w3.org/2000/svg"},
        pathIcon: {
            d:"M16.0001 4H18.0001C18.5305 4 19.0392 4.21071 19.4143 4.58579C19.7894 4.96086 20.0001 5.46957 20.0001 6V20C20.0001 20.5304 19.7894 21.0391 19.4143 21.4142C19.0392 21.7893 18.5305 22 18.0001 22H6.00009C5.46966 22 4.96095 21.7893 4.58588 21.4142C4.21081 21.0391 4.00009 20.5304 4.00009 20V6C4.00009 5.46957 4.21081 4.96086 4.58588 4.58579C4.96095 4.21071 5.46966 4 6.00009 4H8.00009M9.00009 2H15.0001C15.5524 2 16.0001 2.44772 16.0001 3V5C16.0001 5.55229 15.5524 6 15.0001 6H9.00009C8.44781 6 8.00009 5.55229 8.00009 5V3C8.00009 2.44772 8.44781 2 9.00009 2Z", fill:["#0F4187", ""], stroke:["white", "black"],  stroke_opacity:["", "0.6" ], stroke_width:"1.5", stroke_linecap:"round", stroke_linejoin:"round"}
    },
    {
        title : 'Profile',
        path : '/akunku',
        svg : {
            width:"24",
            height:"24", 
            viewBox:"0 0 24 24",
            fill:"#F5F9FF",
            xmlns:"http://www.w3.org/2000/svg",
        pathIcon : {
            d:"M1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11Z",
            fill:"#F5F9FF",
            stroke:["white", "black"],
            stroke_opacity:["", "0.6" ],
            stroke_width: "1.5",
        },
        },
    }
]
